import usePostPutDelete, { ReqType } from './usePostPutDelete/usePostPutDelete';
import usePostPutWithFormData from './usePostPutWithFormData/usePostPutWithFormData';

export const usePost = usePostPutDelete(ReqType.POST);
export const usePut = usePostPutDelete(ReqType.PUT);
export const useDelete = usePostPutDelete(ReqType.DELETE);

export const usePostWithFormData = usePostPutWithFormData(ReqType.POST);
export const usePutWithFormData = usePostPutWithFormData(ReqType.PUT);
